"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerListFlags = void 0;
var SignerListFlags;
(function (SignerListFlags) {
    SignerListFlags[SignerListFlags["lsfOneOwnerCount"] = 65536] = "lsfOneOwnerCount";
})(SignerListFlags = exports.SignerListFlags || (exports.SignerListFlags = {}));
//# sourceMappingURL=SignerList.js.map